import { Button, Row, Skeleton } from '@microfrontends/react-components'
import { useEffect, useState } from 'react'
import { ICompanyListResponse } from '../../services/companyListService'
import { useStore } from '../../store'
import { ContentWrapper } from '../Banner/Banner.css'
import CompanySearchItem from '../CompanySearchItem'
import NoResultIcon from '../Icons/NoResultIcon'
import {
    ClearKeyword,
    CompanySearchResultList,
    CompanySearchResultListLoading,
    CompanySearchResultWrapper,
    Keyword,
    KeywordCount,
    NoResultWrapper,
    SearchDescription,
    ViewMoreButtonWrapper
} from './CompanySearchResult.css'

export interface ICompanySearchResultProps {
    companyList: ICompanyListResponse[]
    keyword: string
    isHaveMore: boolean
    isSearching: boolean
    handleOnClickViewMore: () => void
    setKeyword: (keyword: string) => void
    t: (value: string) => string
}

const CompanySearchResult = (props: ICompanySearchResultProps) => {
    const { keyword, companyList, isHaveMore, isSearching, handleOnClickViewMore, setKeyword, t } = props
    const [noResultKeyword, setNoResultKeyword] = useState<string>('')
    const { isMobile } = useStore().state

    useEffect(() => {
        if (keyword !== '') {
            setNoResultKeyword(keyword)
        }
    }, [keyword])

    if (isSearching) {
        return (
            <>
                <CompanySearchResultWrapper>
                    <Row>
                        <ContentWrapper isMarginTop isPadding hasBg hasBorder>
                            <h2>{t('Company Search Result')}</h2>
                            <SearchDescription>
                                {t('We found')} <KeywordCount>{0}</KeywordCount> {t('company matching with')}{' '}
                                <Keyword>{keyword}</Keyword>
                            </SearchDescription>
                            <CompanySearchResultListLoading>
                                <Skeleton height={110} />
                                <Skeleton height={110} />
                                <Skeleton height={110} />
                                <Skeleton height={110} />
                                <Skeleton height={110} />
                                <Skeleton height={110} />
                                <Skeleton height={110} />
                                <Skeleton height={110} />
                                <Skeleton height={110} />
                                <Skeleton height={110} />
                            </CompanySearchResultListLoading>
                        </ContentWrapper>
                    </Row>
                </CompanySearchResultWrapper>
            </>
        )
    }

    return (
        <>
            <CompanySearchResultWrapper>
                <Row>
                    {companyList[0] && companyList[0].data && companyList[0]?.data?.length > 0 ? (
                        <>
                            <ContentWrapper
                                isMarginTop
                                isPadding
                                isTransparentOnMobile
                                disablePaddingMobile
                                hasBg
                                hasBorder
                            >
                                {isMobile ? null : <h2>{t('Company Search Result')}</h2>}
                                <SearchDescription>
                                    {t('We found')} <KeywordCount>{companyList[0].meta.nbHits || 0}</KeywordCount>{' '}
                                    {companyList[0].meta.nbHits && companyList[0].meta.nbHits > 1
                                        ? t('companies matching with')
                                        : t('company matching with')}{' '}
                                    <Keyword>&quot;{keyword}&quot;</Keyword>
                                </SearchDescription>
                                <CompanySearchResultList>
                                    {companyList &&
                                        companyList.map((companySearchResult, index) => {
                                            return (
                                                companySearchResult.data &&
                                                companySearchResult.data.map((companyItem, companyIndex) => {
                                                    return (
                                                        <CompanySearchItem
                                                            key={`company-search-item-${index}-${companyIndex}`}
                                                            companyInfo={companyItem}
                                                        />
                                                    )
                                                })
                                            )
                                        })}
                                </CompanySearchResultList>
                                {isHaveMore ? (
                                    <ViewMoreButtonWrapper>
                                        <Button onClick={handleOnClickViewMore} style={{ width: 180 }}>
                                            {t('View more')}
                                        </Button>
                                    </ViewMoreButtonWrapper>
                                ) : null}
                            </ContentWrapper>
                        </>
                    ) : (
                        <>
                            <ContentWrapper isMarginTop isPadding hasBg hasBorder>
                                <h2>{t('No results found')}</h2>
                                <NoResultWrapper>
                                    <NoResultIcon />
                                    <p>
                                        {t('We found')} <KeywordCount>0</KeywordCount> {t('company matching with')}{' '}
                                        <Keyword>&quot;{noResultKeyword}&quot;</Keyword>
                                    </p>
                                    <ClearKeyword
                                        onClick={() => {
                                            setKeyword('')
                                            const element: HTMLInputElement | null =
                                                document.querySelector('#company-search-input')
                                            if (element === null) {
                                                return
                                            }
                                            element.focus()
                                        }}
                                    >
                                        {t('Clear keyword')}
                                    </ClearKeyword>
                                </NoResultWrapper>
                            </ContentWrapper>
                        </>
                    )}
                </Row>
            </CompanySearchResultWrapper>
        </>
    )
}

export default CompanySearchResult
